import { useGetCorrectnessBreakdown } from './useGetCorrectnessBreakdown'
import { useGetTaskCompletion } from './useGetTaskCompletion'
import { useGetTaskOutcome } from './useGetTaskOutcome'
import { useGetVolume } from './useGetVolume'

export const stats = {
  getCorrectnessBreakdown: useGetCorrectnessBreakdown,
  getTaskCompletion: useGetTaskCompletion,
  getTaskOutcome: useGetTaskOutcome,
  getVolume: useGetVolume,
}
